import React from 'react';
import PropTypes from 'prop-types';
import A from '../Anchor';

/**
 * Used for custom click tracking with EPI find.
 *
 * Params `HitId`, `query`, `Trackid` are required to get correct tracking.
 *
 * Other props will be spread to the native <a> element.
 *
 */
const ClickTrackLink = ({
  HitId,
  DisableClickTracking,
  TrackId,
  query,
  children,
  href,
  NewTab,
  className,
  containsLinks,
  ...attr
}) => {
  function trackClick() {
    fetch(
      `/api/v2/search/trackclick?hitId=${HitId}&query=${query}&trackId=${TrackId}`
    );
  }

  const trackLinkClick = () =>
    !DisableClickTracking && TrackId ? trackClick() : undefined;

  return containsLinks ? (
    <div className={className} {...attr}>
      {children}
    </div>
  ) : (
    <A
      {...attr}
      onClick={() => {
        trackLinkClick();
      }}
      href={href}
      NewTab={NewTab}
      className={className}
    >
      {children}
    </A>
  );
};

ClickTrackLink.propTypes = {
  /** (BE) */
  HitId: PropTypes.string,
  /** (BE) */
  TrackId: PropTypes.string,
  /** (BE) */
  DisableClickTracking: PropTypes.bool,
  query: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.string.isRequired,
  NewTab: PropTypes.bool,
  className: PropTypes.string,
  containsLinks: PropTypes.bool,
};

export default ClickTrackLink;
